import type { ToolMeta } from './registry';

export const getChecklistTasksMeta = {
  description:
    "The couple's checklist as their checklist page lists it: the next groups, one month's, or a number of them. The standard 'what's next?' tool.",
  examples: [
    'What are our next tasks?',
    'What should we focus on next?',
    "What's on our list in March?",
  ],
  value: 'their checklist, as their checklist page lists it',
  grounding: 'planning-timeline',
} as const satisfies ToolMeta;
